import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { AdminMutationKey } from '../../../keys'
import {
	OperatorDataResponse,
	UpdateOperatorRequest,
} from '@/modules/manage-operator/types'
import { updateOperator } from '../../services'

export default function useMutationUpdateOperator(
	operatorId: string,
	props?: UseBaseMutationOptions<OperatorDataResponse, UpdateOperatorRequest>,
) {
	return useMutation({
		mutationKey: [AdminMutationKey.UpdateOperator, operatorId],
		mutationFn: (params) => updateOperator(operatorId, params),
		...props,
	})
}
